import { PORTRAIT_DARK, PORTRAIT_STANDING } from "@/lib/content";

export const DEFAULT_THEME = {
  colors: {
    paper: "#EFEDE6",
    ink: "#101010",
    char: "#26251F",
    noir: "#0A0A0A",
    accent: "#101010",
  },
  fonts: { display: "Switzer", body: "Switzer", serif: "Playfair Display" },
  spacing: { section: "normal" },
};

const btn = (id, ro, en, href, style) => ({
  id,
  label: { ro, en },
  href,
  visible: true,
  style,
});

export const DEFAULT_SECTIONS = {
  order: ["home_services", "koolt", "home_works", "home_courses", "home_journal", "media"],
  items: {
    hero: {
      visible: true,
      type: "builtin",
      buttons: [
        btn("cta", "Vezi lucrările", "View my work", "https://www.koolt.co/", "solid"),
        btn("cta2", "Despre mine", "About", "/about", "outline"),
      ],
    },
    home_services: { visible: true, type: "builtin", buttons: [btn("svc", "Toate serviciile", "All services", "/services", "outline")] },
    koolt: { visible: true, type: "builtin", buttons: [btn("koolt", "Vizitează Koolt", "Visit Koolt", "https://www.koolt.co/", "solid")] },
    home_works: { visible: true, type: "builtin", buttons: [btn("wrk", "Toate lucrările", "All work", "/portfolio", "outline")] },
    home_courses: { visible: true, type: "builtin", buttons: [btn("crs", "Vezi cursurile", "Browse courses", "/library", "outline")] },
    home_journal: { visible: true, type: "builtin", buttons: [btn("jrn", "Toate eseurile", "All essays", "/journal", "outline")] },
    media: { visible: true, type: "builtin", buttons: [] },
    principles: { visible: true, type: "builtin", buttons: [] },
  },
};

export const DEFAULT_IMAGES = {
  about_portrait: PORTRAIT_STANDING,
  about_secondary: PORTRAIT_DARK,
};

export const BUILTIN_SECTION_KEYS = ["hero", "home_services", "koolt", "home_works", "home_courses", "home_journal", "media", "principles"];

// ---------- Fonts ----------
export const FONT_LIST = [
  "Switzer",
  "Chivo",
  "Cormorant Garamond",
  "Manrope",
  "Inter",
  "Playfair Display",
  "Space Grotesk",
  "Archivo",
  "Libre Baskerville",
  "Fraunces",
  "Syne",
  "Bodoni Moda",
];

export const FONT_MAP = {
  Switzer: { stack: "'Switzer','Helvetica Neue',Arial,sans-serif", google: null },
  Chivo: { stack: "'Chivo','Archivo',sans-serif", google: "Chivo:wght@400;500;600;700;800;900" },
  "Cormorant Garamond": { stack: "'Cormorant Garamond',Georgia,serif", google: "Cormorant+Garamond:wght@300;400;500;600;700" },
  Manrope: { stack: "'Manrope',sans-serif", google: "Manrope:wght@300;400;500;600;700;800" },
  Inter: { stack: "'Inter',sans-serif", google: "Inter:wght@300;400;500;600;700;800" },
  "Playfair Display": { stack: "'Playfair Display',Georgia,serif", google: "Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600" },
  "Space Grotesk": { stack: "'Space Grotesk',sans-serif", google: "Space+Grotesk:wght@300;400;500;600;700" },
  Archivo: { stack: "'Archivo',sans-serif", google: "Archivo:wght@300;400;500;600;700;800;900" },
  "Libre Baskerville": { stack: "'Libre Baskerville',Georgia,serif", google: "Libre+Baskerville:ital,wght@0,400;0,700;1,400" },
  Fraunces: { stack: "'Fraunces',Georgia,serif", google: "Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400" },
  Syne: { stack: "'Syne',sans-serif", google: "Syne:wght@400;500;600;700;800" },
  "Bodoni Moda": { stack: "'Bodoni Moda',Georgia,serif", google: "Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,600;0,6..96,700;1,6..96,400" },
};

export function fontStack(name) {
  return (FONT_MAP[name] || FONT_MAP.Switzer).stack;
}

export function loadFont(name) {
  const cfg = FONT_MAP[name];
  if (!cfg || !cfg.google) return;
  const id = `om-font-${name.replace(/\s+/g, "-")}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${cfg.google}&display=swap`;
  document.head.appendChild(link);
}

export function normalizeSections(s) {
  s = s || {};
  const order =
    Array.isArray(s.order) && s.order.length ? s.order.slice() : DEFAULT_SECTIONS.order.slice();
  const items = { ...(s.items || {}) };
  for (const k of Object.keys(DEFAULT_SECTIONS.items)) {
    items[k] = { ...DEFAULT_SECTIONS.items[k], ...(s.items?.[k] || {}) };
  }
  return { order, items };
}

export function normalizeConfig(raw) {
  raw = raw || {};
  return {
    theme: {
      colors: { ...DEFAULT_THEME.colors, ...(raw.theme?.colors || {}) },
      fonts: { ...DEFAULT_THEME.fonts, ...(raw.theme?.fonts || {}) },
      spacing: { ...DEFAULT_THEME.spacing, ...(raw.theme?.spacing || {}) },
    },
    sections: normalizeSections(raw.sections),
    content: raw.content || { ro: {}, en: {} },
    images: raw.images || {},
    updated_at: raw.updated_at,
  };
}
